// extracted by mini-css-extract-plugin
module.exports = {"xs-text":"Disclaimers_xs-text_2s2aT","bold":"Disclaimers_bold_3YAZS","margin-top":"Disclaimers_margin-top_2-SnM","toggle":"Disclaimers_toggle_tEzue"};